import React from 'react';
import { css } from '@emotion/react';

import Modal from '$/components/ui/Modal';
import MessageEvent from '$/components/Socket/MessageEvent';

import { SocketNotification } from '$/GraphQL/schema/schema';

const ConfirmPaymentModal: React.FC = ({}) => {
  const [redirectUrl, setRedirectUrl] = React.useState<string | undefined>();

  const onClose = React.useCallback(() => {
    setRedirectUrl(undefined);
  }, []);

  const onReceiveMessage = React.useCallback((notification: SocketNotification): void => {
    if (notification.verifyPayment) {
      setRedirectUrl(notification.verifyPayment.iframeUrl);
    }
  }, []);

  React.useEffect(() => {
    const listener = (event: MessageEvent): void => {
      if (event.data === '3DS-authentication-complete') {
        onClose();
      }
    };
    window.addEventListener('message', listener);
    return (): void => {
      window.removeEventListener('message', listener);
    };
  }, [onClose]);

  return (
    <>
      <Modal
        css={css`
          width: 600px;
          height: 90vh;
          max-height: 600px;
        `}
        hide={!redirectUrl}
        onClose={onClose}
      >
        <iframe
          className='w-full h-full'
          css={css`
            border-radius: 0.5rem;
          `}
          src={redirectUrl}
        />
      </Modal>
      <MessageEvent handler={onReceiveMessage} />
    </>
  );
};

export default ConfirmPaymentModal;
